// ── Design tokens ────────────────────────────────────────────────────────────

export const CORAL = "#D1004B";
export const F = "var(--font-sans)";

export const T = {
  bg: "#f5f5f5",
  surface: "#ffffff",
  s2: "#f2f2f2",
  border: "#e8e8e8",
  text: "#0a0a0a",
  sub: "#666666",
  muted: "#b0b0b0",
  sidebar: "#0d0d0d",
  sidebarText: "#e0e0e0",
  sidebarSub: "#666",
  sidebarActive: "rgba(209,0,75,0.18)",
  sidebarActiveBorder: CORAL,
};
